// (___) ___-___
export const applyPhoneMask = (phone: string): string => {
  if (!phone) return "";

  const num = phone.replace(/\D/g, "");

  if (num.length < 4) {
    return `(${num.slice(0, 3)}`;
  }

  if (num.length >= 4 && num.length < 7) {
    return `(${num.slice(0, 3)}) ${num.slice(3)}`;
  }

  if (num.length >= 7 && num.length <= 10) {
    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
  }

  // limits inputting more and allows to "insert numbers"
  if (num.length > 10) {
    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}`;
  }

  return "";
};

export const demaskPhoneValue = (maskedPhone: string) => {
  if (!maskedPhone) return "";
  // Remove non-digit characters
  const unmaskedPhone = maskedPhone.replace(/\D/g, "");

  if (unmaskedPhone.length > 10) {
    return unmaskedPhone.substring(
      unmaskedPhone.length - 10,
      unmaskedPhone.length
    );
  }
  return unmaskedPhone;
};
